import { createSlice } from '@reduxjs/toolkit'

import graphs_data from '../utils/data.json';

const initialState = {
    user_id: 1,
    complete_data: [...graphs_data.data],
    current_performance: 0,
    presence: [],
    grit: {effort: [], intrest: [], x_labels: []},
    competitiveness: {x_labels: [], data:[]},
};

export const graphsSlice = createSlice({
    name: 'graphs',
    initialState,
    reducers: {
        updatePresenceData: (state, action) => {
            const presence_data = state.complete_data.map((user_data) => {
                const data = user_data.performance_metrics.presence;
                return {
                    name: user_data.id === state.user_id ? 'You' : '',
                    y: 1, // width of pie slice
                    z: data.action + data.mindfulness + data.acceptance + data.awareness, // radius of pie slice
                    color: user_data.id === state.user_id ? '#00ae00' : '#3dc3e8',
                    "action": data.action,
                    "mindfulness": data.mindfulness,
                    "acceptance": data.acceptance,
                    "awareness": data.awareness
                }
            });

            state.presence = presence_data;
        },
        updateGritData: (state, action) => {
            const effort = state.complete_data.map((user_data) => {
                return user_data.performance_metrics.grit.effort;
            });
            const intrest = state.complete_data.map((user_data) => {
                return user_data.performance_metrics.grit.intrest;
            });
            const x_labels = state.complete_data.map((user_data) => {
                return user_data.id === state.user_id ? 'You' : '';
            });

            state.grit = {
                effort: effort,
                intrest: intrest,
                x_labels: x_labels,
            };
        },
        updateCompetitivenessData: (state, action) => {
            const prizes_data = [];
            const progress_data = [];
            const pressure_data = [];
            const x_labels = [];

            state.complete_data.forEach(user_data => {
                prizes_data.push(user_data.performance_metrics.competitiveness.prizes);
                progress_data.push(user_data.performance_metrics.competitiveness.progress);
                pressure_data.push(user_data.performance_metrics.competitiveness.pressure);

                x_labels.push(user_data.id === state.user_id ? 'You' : '')
            });

            state.competitiveness = {
                data: [
                    { name: 'Prizes', data: prizes_data },
                    { name: 'Progress', data: progress_data },
                    { name: 'Pressure', data: pressure_data },
                ],
                x_labels: x_labels,
            };
        },
        updateCurrentPerformance: (state, action) => {
            const performance_score = [];
            const x_labels = [];
            state.complete_data.forEach(user_data => {
                performance_score.push(user_data.performance_metrics.current_performance);
                x_labels.push(user_data.id === state.user_id ? 'You' : '');
            });

            state.current_performance = {
                data: performance_score,
                x_labels: x_labels,
            };
        }
    },
})

// Action cretors are generated for each case reducer function
export const { 
    updatePresenceData,
    updateGritData,
    updateCompetitivenessData,
    updateCurrentPerformance,
} = graphsSlice.actions;

export const graphsReducer = graphsSlice.reducer;

